<template>
  <div>
    <v-card
      class="mx-auto"
      color="transparent"
      elevation="0"
    >
      <v-card
        :style="`z-index: 1; position: sticky; top: ${focusModeToolbarTop()};`"
        color="rgba(255, 255, 255, 0.8)"
      >
        <EditToolbar>
          <template #title-section>
            <v-btn small icon fab class="px-0" text :to="{ name: 'jobs', params: { contentTypeLabel: 'besoins' } }">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>

            <v-toolbar-title v-if="!isViewMode" class="text-body text-md-h6">{{ hasUuid ? 'Modifier cet': 'Ajouter un' }} intitulé de poste</v-toolbar-title>
            <v-toolbar-title v-else class="text-body text-md-h6">Voir les intitulés de poste</v-toolbar-title>
          </template>

          <template #desktop-actions>
            <v-btn v-if="!isViewMode && (isCreateMode || isDraft)" color="primary" :disabled="(hasUuid ? !canPerformAction('EDIT_JOB') : !canPerformAction('CREATE_JOB')) || !canSave || jobData.status === 'published'" @click="saveJob(jobData.status === 'published' ? 'published' : 'draft')">
              Enregistrer
            </v-btn>

            <v-btn v-if="hasUuid && !isCreateMode" color="success" :disabled="(loading.form || loading.skeleton) || !hasUuid || !canPerformAction('GENERATE_OFFER')" @click="generatedOffer()">
              Générer l'offre
            </v-btn>

            <v-btn v-if="!isViewMode && (isEditMode && isDraft)" :disabled="!canReset" @click="resetModifications">
              Annuler les modifications
            </v-btn>
          </template>

          <template #mobile-actions>
            <v-list-item v-if="!isViewMode && (isCreateMode || isDraft)" color="primary" :disabled="(hasUuid ? !canPerformAction('EDIT_JOB') : !canPerformAction('CREATE_JOB')) || !canSave || jobData.status === 'published'" @click="saveJob(jobData.status === 'published' ? 'published' : 'draft')">
              <v-list-item-icon>
                <v-icon>mdi-content-save</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Enregistrer</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="hasUuid && !isCreateMode" color="success" :disabled="(loading.form || loading.skeleton) || !hasUuid || !canPerformAction('GENERATE_OFFER')" @click="generatedOffer()">
              <v-list-item-icon>
                <v-icon>mdi-newspaper-variant</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Générer l'offre</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="!isViewMode && (isEditMode && isDraft)" :disabled="!canReset" @click="resetModifications">
              <v-list-item-icon>
                <v-icon>mdi-refresh</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Annuler les modifications</v-list-item-title>
            </v-list-item>
          </template>

          <template #after-actions>
            <ActionsContent
              v-if="isViewMode"
              :actions="[activeBoardConfiguration.actions.edit]"
              :item="jobData"
              :content-type-label="'besoins'"
              class="ml-2"
            />

            <v-btn
              v-if="!loading.skeleton && Object.keys(mandatoryFields).length && $vuetify.breakpoint.smAndDown"
              color="primary"
              absolute
              right
              fab
              small
              style="top: 62px; z-index: 1000;"
              @click="drawer = true"
            >
              <v-icon>mdi-alert-circle</v-icon>
            </v-btn>
          </template>
        </EditToolbar>

        <v-progress-linear
          v-if="loading.form"
          indeterminate
          color="primary"
        />
      </v-card>

      <v-row
        class="my-8 px-4 px-md-8"
        :class="{ 'mt-12' : focusMode }"
        no-gutters
      >
        <v-col
          cols="12"
          :md="Object.keys(mandatoryFields).length ? 8 : 12"
          class="pa-0"
        >
          <v-card-text class="pa-0">
            <v-form
              v-model="isValidForm"
              class="d-flex flex-column"
              style="gap: 26px;"
            >
              <fieldset
                v-for="(panel, panelIndex) in rawContentTypes('Job').panelOrder"
                :key="panelIndex"
                class="d-flex flex-column py-4 px-4"
                style="gap: 16px; border-radius: 10px; border: 0; background: white;"
              >
                <legend
                  class="
                    py-2 px-4
                    overline text-h6 rounded-lg
                  "
                  style="background-color: #e0e0e0;"
                >
                  {{ panel }}
                </legend>

                <template
                  v-for="(input, inputIndex) in getPanel(panel)"
                >
                  <div
                    v-if="computedFields[input.name] && !(input.name === 'convention' && (!positionConventions.length))"
                    :ref="input.name"
                    :key="inputIndex"
                    class="px-0 px-md-10"
                    style="background: white; border-radius: 10px;"
                  >
                    <v-skeleton-loader
                      v-if="loading.skeleton"
                      type="list-item"
                    />
                    <template
                      v-else
                    >
                      <template
                        v-if="!['convention'].includes(input.name)"
                      >
                        <div class="d-flex align-center" style="gap: 16px;">
                          <component
                            :is="input.component ? input.component : 'GenericField'"
                            v-model="jobData[input.name]"
                            :name="input.name"
                            :data="jobData"
                            :helper-data="helperData"
                            :input="input"
                            :field="computedFields[input.name]"
                            :items="getFieldItems(computedFields[input.name])"
                            :options="references"
                            :classes="getInputClasses(computedFields[input.name])"
                            :clearable="!isViewMode"
                            @item="handleItem"
                            @init-position="handlePosition"
                            class="flex-grow-1"
                          />
                          <!-- <v-btn
                            v-if="input.name === 'position' && jobData.position"
                            icon
                            fab
                            class="px-0"
                            @click="openFile"
                          >
                            <v-icon>mdi-download</v-icon>
                          </v-btn> -->
                        </div>
                      </template>
                      <template
                        v-else-if="input.name === 'convention'"
                      >
                        <component
                          :is="'GenericField'"
                          v-model="jobData.convention"
                          :name="input.name"
                          :data="jobData"
                          :items="positionConventions"
                          :helper-data="helperData"
                          :input="input"
                          :field="{ ...computedFields.convention, label: input.label }"
                          :classes="getInputClasses(computedFields.convention)"
                          :clearable="!isViewMode"
                        />
                      </template>
                      <span
                        v-if="computedFields[input.name].hintText"
                        class="overlap text--secondary"
                      >
                        Message d'indication: {{ computedFields[input.name].hintText }}
                      </span>
                    </template>
                  </div>
                </template>
              </fieldset>
            </v-form>
          </v-card-text>
        </v-col>
        <v-col
          v-if="Object.keys(mandatoryFields).length && !$vuetify.breakpoint.smAndDown"
          cols="4"
          class="pl-4"
        >
          <div
            class="pt-6"
            :style="`position: sticky; top: ${focusModeToolbarTop('mandatoryFields')};`"
          >
            <MandatoryFieldsSection
              :mandatory-fields="mandatoryFields"
              :is-loading="loading.skeleton"
              @scroll-to-field="scrollToField"
            />
          </div>
        </v-col>
      </v-row>
    </v-card>

    <!-- Mobile: Drawer -->
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      right
      style="z-index: 1000;"
    >
      <MandatoryFieldsSection
        :mandatory-fields="mandatoryFields"
        :is-loading="loading.skeleton"
        is-flat
        @scroll-to-field="scrollToField"
      />
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import { requests } from '@/mixins/index';

import GenericField from '@/components/dynamic/form/templates/GenericField.vue';
import DatePicker from '@/components/dynamic/form/components/DatePicker.vue';
import PositionInput from '@/components/forms/PositionInput.vue';
import ActionsContent from '@/components/dataTable/components/ActionsContent.vue';
import MandatoryFieldsSection from '@/components/dataTable/components/MandatoryFieldsSection.vue';
import EditToolbar from '@/components/layouts/components/EditToolbar.vue';

export default {
  components: { GenericField, DatePicker, PositionInput, ActionsContent, MandatoryFieldsSection, EditToolbar },
  data () {
    return {
      drawer: false,
      jobData: {},
      defaultData: {},
      positionConventions: [],
      positions: [],
      helperData: {},
      isValidForm: false,
      extensionPanel: 0,
      fieldOverrides: {},
      loading: {
        skeleton: this.$route.params.mode !== 'creer',
        form: this.$route.params.mode !== 'creer'
      }
    };
  },
  computed: {
    ...mapState(['activeBoardConfiguration', 'focusMode']),
    ...mapGetters(['canPerformAction', 'hasWorkspaceAccess']),
    hasUuid () {
      return !!this.$route.params.uuid;
    },
    isEditMode () {
      return this.$route.params.mode === 'editer';
    },
    isViewMode () {
      return this.$route.params.mode === 'vue';
    },
    isCreateMode () {
      return this.$route.params.mode === 'creer';
    },
    rawContentTypes () {
      return contentType => this.$store.state.rawContentTypes?.[contentType] || {};
    },
    computedFields () {
      const fields = {};

      this.inputs.forEach(input => {
        const rawContentType = this.rawContentTypes(input.rawContentType);
        if (!rawContentType?.fields || typeof rawContentType.fields !== 'object') return;

        const field = rawContentType.fields[input.name];
        if (!field) return;

        const fieldOverride = this.fieldOverrides[input.name] || {};
        const commonProps = { ...input, ...field, ...fieldOverride };

        if ((this.isViewMode && !input.alwaysEditable) || this.jobData.status === 'published') {
          fields[input.name] = { ...commonProps, readonly: true, disabled: true };
        } else {
          fields[input.name] = commonProps;
        }
      });

      return fields;
    },
    getDashboardField () {
      return fieldValue => {
        const foundedField = this.$store.state.activeBoardConfiguration?.dashboardFields.find(field => field.value === fieldValue);
        return foundedField || null;
      };
    },
    inputs () {
      return this.$store.state.activeBoardConfiguration?.inputs || [];
    },
    references () {
      return this.$store.state.references || {};
    },
    workspace () {
      return this.$store.state.activeWorkspace || {};
    },
    mandatoryFields () {
      if (!this.rawContentTypes('Job')?.panelOrder || !this.jobData) return {};

      const mandatoryFieldsByPanel = {};

      this.rawContentTypes('Job').panelOrder.forEach(panelName => {
        const panelInputs = this.getPanel(panelName);

        const mandatoryInPanel = panelInputs.reduce((accumulator, input) => {
          const field = this.computedFields[input.name];
          const isMandatory = field && (field.mandatory || input.mandatory);
          const isMissing = !this.jobData[input.name];

          if (isMandatory && isMissing) {
            accumulator.push({ ...field, name: input.name });
          }
          return accumulator;
        }, []);

        // If we found any mandatory fields for this panel, add them to our result object.
        if (mandatoryInPanel.length > 0) {
          mandatoryFieldsByPanel[panelName] = mandatoryInPanel;
        }
      });

      return mandatoryFieldsByPanel;
    },
    isDraft () {
      return ('status' in this.jobData && this.jobData.status === 'draft');
    },
    canPublish () {
      return !this.loading.form && this.isValidForm && this.isDraft;
    },
    canSave () {
      return !this.loading.form && (this.hasChanges && this.jobData.name);
    },
    canReset () {
      return !this.loading.form && this.hasChanges;
    },
    hasChanges () {
      const replacer = (key, value) => (value === '' ? null : value);
      return JSON.stringify(this.jobData, replacer) !== JSON.stringify(this.defaultData, replacer);
    },
    focusModeToolbarTop () {
      return (section = null) => {
        if (this.$vuetify.breakpoint.xsOnly) {
          return '64px';
        }

        if (section === 'mandatoryFields') {
          return this.focusMode ? '112px' : '150px';
        }

        return this.focusMode ? '24px' : '88px';
      };
    }
  },
  watch: {
    inputs: {
      handler () {
        this.jobData = this.initializeData();
        this.defaultData = { ...this.jobData };
      },
      deep: true,
      immediate: true
    }
  },
  async mounted () {
    if (!this.hasUuid) return;

    await this.getJobData();

    if (this.isEditMode && this.jobData.status === 'published') {
      this.$router.push({ name: 'job', params: { contentTypeLabel: 'besoins', mode: 'vue', uuid: this.$route.params.uuid } });
    }
  },
  methods: {
    getInputClasses (field) {
      const classes = [field.mandatory ? 'required' : ''];

      classes.push('input-color-black');

      return classes.join(' ');
    },
    initializeData () {
      return this.inputs.reduce((acc, input) => {
        acc[input.name] = input.defaultValue || null;
        return acc;
      }, {});
    },
    async getJobData () {
      this.setLoading(['skeleton', 'form'], true);

      try {
        const response = await requests.getJob(this.$route.params.uuid);

        if (!response.success || !response.data) {
          this.$store.commit('setSnackbar', { text: 'Contenu introuvable', color: 'error' });
          this.$router.push({ name: 'jobs', params: { contentTypeLabel: 'besoins' } });

          return;
        }

        const { position, tradeUnit, convention, marque, offerFAQs, status, workspace, ...restData } = response.data;

        const accessType = this.isEditMode ? 'WRITE' : 'READ';
        if (!this.hasWorkspaceAccess(workspace, accessType)) {
          this.$router.push({ name: 'error', params: { errorCode: 401 } });
          return;
        }

        this.$store.commit('setActiveWorkspace', workspace);

        this.jobData = {
          status: status,
          position: position?.uuid || '',
          convention: convention?.uuid || '',
          marque: marque?.uuid || '',
          tradeUnit: tradeUnit?.uuid || '',
          offerFAQs: offerFAQs?.uuid || '',
          ...restData
        };

        this.defaultData = { ...this.jobData };

        // this.positionConventions = this.getInputConventions(this.isEditMode ? position?.convention : [convention]);
      } catch (error) {
        this.$store.commit('setSnackbar', {
          text: 'Contenu introuvable',
          color: 'error'
        });
        this.$router.push({
          name: 'dynamic-form',
          params: {
            contentTypeLabel: 'besoins',
            mode: 'creer'
          }
        });
      } finally {
        this.setLoading(['skeleton', 'form'], false);
      }
    },
    generatedOffer () {
      this.$store.commit('setDialog', { show: true, title: 'Confirmation', text: 'Souhaitez-vous procéder à la génération de l\'offre ?', handleAccept: () => this.saveJob('published', true) });
    },
    async saveJob (status = 'draft', generatedOffer = false) {
      this.setLoading('form', true);

      const { configs } = this.rawContentTypes('Job');

      const response = await requests.saveJob({
        input: {
          ...this.jobData,
          generatedOffer: generatedOffer,
          workspace: this.workspace,
          status
        },
        isEditMode: this.hasUuid,
        mutationName: this.hasUuid ? configs.update : configs.create
      });

      if (!response.success) {
        // SHOW ERROR MESSAGE
        console.error(response.message);
        this.$store.commit('setSnackbar', { text: 'Une erreur est survenue lors de l\'enregistrement du intitulé de poste', color: 'error' });
        this.setLoading('form', false);

        return;
      }

      this.jobData.uuid = response.data.uuid;
      this.jobData.version = response.data.version;
      this.defaultData = { ...this.jobData };

      // If generating an offer, handle the 30-second delay then redirect to the offer page
      if (generatedOffer) {
        this.$store.commit('resetDialog');
        this.$store.commit('setSnackbar', { text: 'Génération de l\'offre en cours...', color: 'info', timeout: -1 });

        await new Promise(resolve => { setTimeout(resolve, 7000); });

        this.$store.commit('setSnackbar', { text: 'Offre générée avec succès.', color: 'success' });

        if (this.$route.name !== 'offers') {
          this.$router.push({ name: 'offers', params: { contentTypeLabel: 'offres' } });
        }
      } else if (this.hasUuid) {
        this.$store.commit('setSnackbar', { text: 'Intitulé de poste enregistré avec succès.', color: 'success' });
      } else {
        this.$store.commit('setSnackbar', { text: 'Intitulé de poste créé avec succès.', color: 'success' });
        this.$router.replace({ name: 'job', params: { contentTypeLabel: 'besoins', mode: 'editer', uuid: response.data.uuid } });
      }

      this.setLoading('form', false);
    },
    resetModifications () {
      this.getJobData();
    },
    getPanel (panel) {
      return this.inputs.filter(input => {
        const computedField = this.computedFields[input.name];
        return [computedField?.panel, input?.panel].includes(panel) ? input : null;
      });
    },
    getFieldItems (field) {
      if (!field.optionsByReference) return [];

      return Object.entries(this.references[field.optionsByReference]).map(([key, value]) => ({ text: value, value: key }));
    },
    scrollToField (field) {
      const element = this.$refs[field];

      if (!element) return;

      const targetElement = Array.isArray(element) ? element[0] : element;

      this.$vuetify.goTo(targetElement, {
        duration: 500,
        offset: 64 + 16,
        easing: 'easeInOutCubic'
      });

      targetElement.querySelector('input, textarea, select')?.focus();
    },
    setLoading (keys, value) {
      [].concat(keys).forEach(key => {
        this.loading[key] = value;
      });
    },
    getInputConventions (convention) {
      return [].concat(convention).reduce((acc, item) => {
        if (!item) return acc;

        acc.push({
          value: item.uuid,
          text: item.name
        });
        return acc;
      }, []);
    },
    handlePosition (position, resetConvention = false) {
      const disabledField = { disabled: true, readonly: true };

      // Case 1: The position is cleared.
      if (!position) {
        this.jobData.name = null;
        this.jobData.experience = null;
        this.jobData.convention = null;
        this.positionConventions = [];

        // Remove the overrides for 'name' and 'experience' fields.
        this.$delete(this.fieldOverrides, 'name');
        this.$delete(this.fieldOverrides, 'experience');
        return;
      }

      // Case 2: A new position is selected.
      const { wtitle, experience, convention } = position;

      // Update the job data.
      this.jobData.name = wtitle;
      this.jobData.experience = experience;
      if (resetConvention) this.jobData.convention = null; // Reset convention selection.

      // Update the available conventions for the dropdown.
      this.positionConventions = this.getInputConventions(convention);

      // Apply overrides to disable the 'name' and 'experience' fields.
      this.$set(this.fieldOverrides, 'name');
      this.$set(this.fieldOverrides, 'experience', experience ? disabledField : {});
    },
    handleItem (item, fieldName) {
      if (fieldName === 'position') {
        this.handlePosition(item, true);
      }
    }
  }
};
</script>

<style scoped>
  .v-list-item__subtitle {
    white-space: break-spaces;
  }

  @container edit-toolbar (max-width: 750px) {
    :deep(.desktop-actions) {
      display: none;
    }

    :deep(.mobile-actions) {
      display: block;
    }
  }
</style>
